import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import StockCardMiddleware from '../../../../middleware/modules/mutation/stock-card';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
import StockCard from "../../../../components/modules/mutation/stock-card";
// middlewares
const mapStateToProps = ({ auth, stockCard }) => ({
  authUser:auth.authUser,
  isProcessing: stockCard.isProcessing,
  isError: stockCard.isError,
  errorMessage: stockCard.errorMessage,
  helperList:stockCard.helperStockCard,
  data: stockCard.data,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getHelper: () => StockCardMiddleware.getHelper(),
      reset: () =>StockCardMiddleware.resetList(),
      getData: (data) => StockCardMiddleware.getData(data),
    },
    dispatch
  );
};
class StockCardContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      show: 0,
    };
  }
  componentWillMount() {
    this.props.reset()
  }


  render() {
    const { authUser } = this.props;
    
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Stock Card List")}
          </title>
        </Helmet>
      <StockCard
        {...this.props}
        authUser={authUser}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StockCardContainer);
